import { markGameClientIframeDomReadyForVitals } from '@/utilities/logger/datadog/vitals';

/** Iframe DOM load — vitals only. GC readiness is gated on the handshake message. */
export const handleLoad = (ref: { current: null | HTMLIFrameElement }) => {
  if (!ref?.current) {
    return;
  }

  markGameClientIframeDomReadyForVitals();
};
